import Icon from "@components/ui/icon";

const EarlyBirdsCounter = ({
  count,
}: {
  count: { hours: string; minutes: string; seconds: string };
}) => {
  return (
    <div className="-tw-mt-2 tw-mb-4 tw-flex tw-min-h-7 tw-items-center tw-whitespace-nowrap tw-rounded-[52px] tw-bg-golden tw-px-1 tw-font-sans tw-text-[13px] tw-font-medium tw-text-golden-900">
      <Icon icon="ri-price-tag-3-line" className="tw-mr-1" />
      Early bird annual discount. Valid for: {count.hours}:{count.minutes}:
      {count.seconds}
    </div>
  );
};

export default EarlyBirdsCounter;
